import { Action, Row } from '@op/opds.opux';
import { CircledIconOwnercustomer } from '@op/opds.opux-icons/circled-service';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ManualUW.module.scss';

export const ManualUWResult = () => {
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.container} data-testid='result-view'>
      <Row center className={styles.icon}>
        <CircledIconOwnercustomer size='medium' />
      </Row>
      <Row center>
        <h1 ref={titleRef} data-testid='result-view-title' tabIndex={-1}>
          {t('manualUWResult.title')}
        </h1>
        <p className={styles.body}>{t('manualUWResult.description')}</p>
      </Row>
      <Row className={styles.links}>
        <Action
          href={t(
            'link.insurancesHomePage.INSURANCES_HOME_PAGE_LINK_URL_AUTHENTICATED'
          )}
          style={{ display: 'block' }}>
          {t('link.insurancesHomePage.text')}
        </Action>
        <Action
          href={t('link.homePage.CUSTOMER_HOME_PAGE_LINK_URL_AUTHENTICATED')}>
          {t('link.homePage.text')}
        </Action>
      </Row>
    </div>
  );
};
